import { useState } from "react";
import { api } from "@/App";
import { KeyRound, Loader2 } from "lucide-react";

export const LostKey = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null); setMsg(null);
    try { const { data } = await api.post("/licence/resend", { email: email.trim() }); setMsg(data.message); }
    catch (x) { const d = x.response?.data?.detail; setErr(typeof d === "string" ? d : "Something went wrong, please try again."); }
    setBusy(false);
  };
  return (
    <section id="lost-key" className="max-w-xl mx-auto mt-6 space-y-4 border border-[#2a2f3d] bg-[#0e1013] p-8 scroll-mt-6" data-testid="lost-key">
      <h2 className="font-display uppercase text-2xl flex gap-2 items-center"><KeyRound size={20} className="text-[#00e5ff]" /> Lost your key?</h2>
      <p className="text-sm text-[#9ba3b4]">Enter the email you used at checkout and we'll send every key bought with it again.</p>
      <form onSubmit={submit} className="flex gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@studio.com" className="flex-1 bg-black border border-[#2a2f3d] px-3 py-2 text-sm outline-none focus:border-[#00e5ff]" data-testid="lost-key-email-input" />
        <button disabled={busy || !email.trim()} className="btn-ghost px-4 py-2 text-xs flex items-center gap-2" data-testid="lost-key-submit-btn">{busy && <Loader2 className="spin" size={12} />} Email my keys</button>
      </form>
      {msg && <p className="text-sm text-[#a3ff4f]" data-testid="lost-key-result">{msg}</p>}
      {err && <p className="text-xs text-[#ff453a]" data-testid="lost-key-error">{err}</p>}
    </section>
  );
};
